import Header from './components/Header';
import Paragraph from './components/Paragraph';
import TextInput from './components/TextInput';
import Label from './components/Label';
import LineBreak from './components/LineBreak';
import Signature from './components/Signature';
import Image from './components/Image';
import Checkboxes from './components/Checkboxes';
import DatePicker from './components/DatePicker';
import HyperLink from './components/HyperLink';

const FormElements = {};

FormElements.Header = Header;
FormElements.Paragraph = Paragraph;
FormElements.Label = Label;
FormElements.TextInput = TextInput;
FormElements.Checkboxes = Checkboxes;
FormElements.DatePicker = DatePicker;
FormElements.LineBreak = LineBreak;
FormElements.Signature = Signature;
FormElements.Image = Image;
FormElements.HyperLink = HyperLink;

export default FormElements;
